<script setup lang="ts">
import type { PropType } from "vue";
import SkeletonElement from "@/components/generic/SkeletonElement/SkeletonElement.component.vue";
import SkeletonOrderCard from "@/components/generic/SkeletonOrderCard/SkeletonOrderCard.component.vue";
import { SkeletonVariant } from "@/components/generic/SkeletonElement/SkeletonElement.model";

defineProps({
  isClosed: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
});
</script>

<template>
  <div class="order-index-main--hint">
    <SkeletonElement
      :variant="SkeletonVariant.Text"
      box-height="20px"
      width="80px"
    />
  </div>
  <div class="order-index-main--orders">
    <SkeletonOrderCard :is-closed="isClosed" />
    <SkeletonOrderCard :is-closed="isClosed" />
    <SkeletonOrderCard :is-closed="isClosed" />
  </div>
</template>
